import Image from "next/image";
import MobileSlider from "./mobileSlider";
import { toWebp } from "@/utils/common";

interface whytrooProps {
  data?: any;
  isMobile?: boolean;
}

const WhyTrootech: React.FC<whytrooProps> = ({ isMobile, data  }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";
  return (
    <section className="relative bg-background-dark text-white pt-[56px] py-[56px] xl:py-[100px] md:pt-[100px] md:py-[80px] overflow-hidden">
      {/* Background Image */}
      <Image
        src="/images/manufacturing/bg-why-blue.png"
        width={571}
        height={571}
        alt="banner-vector"
        className="absolute w-[571px] h-[571px] sm:top-[-80px] top-[-100px] sm:left-0 left-[-50px] z-1 bg-cover bg-no-repeat bg-center  sm:block"
        quality={80}
        loading="eager"
        priority
      />

      <Image
        src="/images/manufacturing/bg-why-green.png"
        width={470}
        height={470}
        alt="banner-vector"
        className="absolute w-[470px] sm:bottom-0 bottom-[-150px] top-[auto] sm:right-0 right-[-50px] z-1 bg-cover bg-no-repeat bg-center  sm:block"
        quality={80}
        loading="eager"
        priority
      />

      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="text-center xl:mb-[40px] md:mb-[120px] ">
          <h2 className="text-heading-1 font-extrabold text-primary-text-white mx-auto max-w-[914px] ">
            {data?.title}
          </h2>
        </div>

        {!isMobile && (
          <>
            {data?.cards?.map((card: any, index: number) => {
              const isEven = (index + 1) % 2 === 0; // even/odd logic

              return (
                <div
                  key={index}
                  className={`flex flex-wrap group xl:mb-[65px] mb-[144px] last:mb-[0] ${isEven ? "flex-row-reverse" : ""}`}
                >
                  {/* Left Content */}
                  <div
                    className={`flex items-center justify-start h-[392px] relative border border-[rgba(64,66,76,1)] w-[calc(100%-50%)] lg:w-[calc(100%-414px)] xl:w-[calc(100%-495px)] ${
                      isEven
                        ? "xl:mr-[105px] flex-row-reverse border-l-0"
                        : "xl:ml-[105px] border-r-0"
                    }`}
                  >
                    {/* Decorative Images */}
                    {!isEven ? (
                      <>
                        <Image
                          src="/images/manufacturing/sys-bottom.png"
                          width={468}
                          height={250}
                          alt="banner-vector"
                          className="absolute w-[468px] h-[250px] top-[0] right-[-235px] hidden sm:block"
                          quality={100}
                          loading="eager"
                          priority
                        />
                        <Image
                          src="/images/manufacturing/sys-top.png"
                          width={346}
                          height={185}
                          alt="banner-vector"
                          className="absolute w-[346px] h-[185px] bottom-0 left-0 hidden sm:block"
                          quality={100}
                          loading="eager"
                          priority
                        />
                      </>
                    ) : (
                      <>
                        <Image
                          src="/images/manufacturing/sys-green-top.png"
                          width={468}
                          height={250}
                          alt="banner-vector"
                          className="absolute w-[468px] h-[250px] top-[0] left-[-235px] hidden sm:block"
                          quality={100}
                          loading="eager"
                          priority
                        />
                        <Image
                          src="/images/manufacturing/sys-green-bottom.png"
                          width={346}
                          height={185}
                          alt="banner-vector"
                          className="absolute w-[346px] h-[185px] bottom-0 right-0 hidden sm:block"
                          quality={100}
                          loading="eager"
                          priority
                        />
                      </>
                    )}

                    {/* Left Box */}
                    <div
                      className={`flex items-center justify-start p-[20px] xl:p-[25px] border border-[rgba(64,66,76,1)] 
                      h-[170px] xl:h-[299px] xl:w-[285px] xl:min-w-[285px] w-[249px] min-w-[249px] 
                      z-40 md:absolute md:top-[-90px] lg:absolute lg:top-[-90px] xl:relative xl:top-[0px]
                      ${
                        isEven
                          ? "xl:mr-[-105px] mr-[32px] bg-[url('/images/manufacturing/green-light.png')] xl:bg-[url('/images/manufacturing/green-light-new.png')]"
                          : "xl:ml-[-105px] ml-[32px] bg-[url('/images/manufacturing/blue-light.png')] xl:bg-[url('/images/manufacturing/blue-light-new.png')]"
                      } bg-no-repeat bg-cover`}
                    >
                      <h2 className="text-heading-5 text-primary-text-white font-bold leading-tight text-left">
                        {card?.title}
                      </h2>
                    </div>

                    {/* Text Content */}
                    <div className="w-full flex items-center justify-start mx-[24px] md:mx-[32px] xl:mx-[24px]">
                      <p className="text-subtitle-1 leading-relaxed max-w-[100%] text-center md:text-left relative z-10">
                        {card?.description}
                      </p>
                    </div>
                  </div>

                  {/* Right Image */}
                  <div className="flex items-center justify-center relative z-10 h-[393px] xl:w-[390px] xl:min-w-[390px] lg:w-[414px] w-[50%] overflow-hidden border border-[rgba(64,66,76,1)]">
                    <Image
                      src={toWebp(
                        `${baseUrl}${card?.image?.data?.attributes?.url}`,
                      )}
                      alt={`card-${index + 1}`}
                      height={393}
                      width={390}
                      quality={100}
                      className="object-cover xl:w-[390px] lg:w-[414px] w-[390px] xl:min-w-[390px] lg:min-w-[414px] h-[393px] duration-500 ease-in-out scale-[1] group-hover:scale-[1.15]"
                    />
                  </div>
                </div>
              );
            })}
          </>
        )}

        {isMobile && (
          <MobileSlider>
            {data?.cards?.map((card: any, index: number) => {
              const isEven = (index + 1) % 2 === 0;

              return (
                <div
                  key={index}
                  className="flex flex-wrap mt-[155px] flex-col-reverse xl:mb-[65px] md:mb-[144px] mb-0"
                >
                  {/* Right Image */}
                  <div className="flex relative z-10 items-center justify-center h-[286px] xl:w-[390px] xl:min-w-[390px] lg:w-[414px] w-[100%] overflow-hidden border border-[rgba(64,66,76,1)]">
                    <Image
                      src={toWebp(
                        `${baseUrl}${card?.image?.data?.attributes?.url}`,
                      )}
                      alt={`card-${index + 1}`}
                      height={393}
                      width={390}
                      quality={100}
                      className="object-cover xl:w-[390px] h-[286px] w-[390px] xl:min-w-[390px] lg:min-w-[414px] lg:w-[414px]"
                    />
                  </div>

                  {/* Left Content */}
                  <div className="flex xl:mr-[105px] items-center justify-start h-[auto] pb-[24px] relative border pt-[73px] border-b-0 border-[rgba(64,66,76,1)] w-[calc(100%-0)] lg:w-[calc(100%-414px)] xl:w-[calc(100%-495px)]">
                    {/* Decorative Images */}
                    {!isEven ? (
                      <>
                        <Image
                          src="/images/manufacturing/sys-bottom.png"
                          width={468}
                          height={250}
                          alt=""
                          className="absolute w-[468px] h-[250px] top-[0] right-[-235px] z-1"
                          quality={80}
                          loading="eager"
                          priority
                        />
                        <Image
                          src="/images/manufacturing/sys-top.png"
                          width={346}
                          height={185}
                          alt=""
                          className="absolute w-[346px] h-[185px] bottom-[-30px] left-[-20px] z-1"
                          quality={80}
                          loading="eager"
                          priority
                        />
                      </>
                    ) : (
                      <>
                        <Image
                          src="/images/manufacturing/sys-green-top.png"
                          width={468}
                          height={250}
                          alt=""
                          className="absolute w-[468px] h-[250px] top-[0] left-[-235px] z-1"
                          quality={80}
                          loading="eager"
                          priority
                        />
                        <Image
                          src="/images/manufacturing/sys-green-bottom.png"
                          width={346}
                          height={185}
                          alt=""
                          className="absolute w-[346px] h-[185px] bottom-[-30px] right-[-40px] z-1"
                          quality={80}
                          loading="eager"
                          priority
                        />
                      </>
                    )}

                    {/* Text Content */}
                    <div className="w-full flex items-center justify-start ml-[16px] mr-[16px]">
                      <p className="text-subtitle-1 max-w-[100%] text-center md:text-left relative z-10">
                        {card?.description}
                      </p>
                    </div>

                    {/* Title Box */}
                    <div
                      className={`absolute xl:relative xl:top-0 top-[-125px] xl:right-[0] md:right-[32px] right-0 left-0 mx-auto flex items-center justify-start p-[25px]
              border border-[rgba(64,66,76,1)] h-[172px] xl:h-[299px] w-[276px] min-w-[285px] bg-no-repeat bg-cover
              ${
                isEven
                  ? "xl:bg-[url('/images/manufacturing/green-light-leak.png')] bg-[url('/images/manufacturing/green-light.png')]"
                  : "xl:bg-[url('/images/manufacturing/blue-light-leak.png')] bg-[url('/images/manufacturing/blue-light.png')]"
              }`}
                    >
                      <h2 className="text-heading-5 text-primary-text-white font-bold leading-tight text-center w-full">
                        {card?.title}
                      </h2>
                    </div>
                  </div>
                </div>
              );
            })}
          </MobileSlider>
        )}
      </div>
    </section>
  );
}

export default WhyTrootech;
